export default __webpack_public_path__ + "static/media/integracao_xp_exterior_fundo_branco.f35bdfb7.gif";